<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${resellerProduct.name}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="resellerProduct" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "reseller-product-view-logs",

  components: { LogListTable },

  props: ["resellerProduct"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
